"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Heading = _interopRequireDefault(require("../Heading/Heading"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardHeaderTitle = function CardHeaderTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "subtitle"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      flexGrow: 1,
      minHeight: 3,
      my: 2,
      mx: 2,
      flexDirection: 'column',
      justifyContent: 'center',
      color: 'text'
    }
  }), (0, _themeUi.jsx)(_Heading["default"], {
    as: "h6"
  }, title), subtitle && (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      color: 'textMediumEmphasis'
    },
    variant: "caption"
  }, subtitle));
};

CardHeaderTitle.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  subtitle: _propTypes["default"].string
};
var _default = CardHeaderTitle;
exports["default"] = _default;